var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutsDirectionSetterRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.165 15.915L19.9923 15.915L18.0773 14L19.9923 12.085L23.165 12.085L23.165 15.915Z",
    stroke: "black",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14L5.75 14",
    stroke: "black",
    strokeWidth: 1.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutsDirectionSetterRight);
export default __webpack_public_path__ + "static/media/callouts-direction-setter-right.169618237d519c98b160f70bccb48c2c.svg";
export { ForwardRef as ReactComponent };